// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__ELrsv","footer":"ModalError_footer__37LU4"};